import React from 'react';
import Input from '../../../../../Core/Fields/Floating/Input';
import SelectSearch from '../../../../../Core/Fields/Floating/SelectSearch';
import CheckboxNew from '../../../../../Core/Fields/Floating/CheckboxNew';

const PurchasingDetails = ({ formData, onFieldChange, extraData }) => {
    return (
        <div>
            <div style={{ display: 'flex', gap: '20px' }}>


                {/* Left Side - Purchasing Details */}
                <div style={{ width: '50%' }}>
                    <div
                        style={{
                            backgroundColor: '#EBE6FA',
                            height: '100%',
                            borderRadius: '4px',
                            display: 'flex',
                            flexDirection: 'column',
                            width: '100%',
                            padding: '10px',
                        }}
                    >
                        <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Purchasing Details</p>
                        <div style={{ display: 'flex', gap: '15px', marginBottom: '10px',marginTop : '10px' }}>
                            <div style={{ flex: 1 }}>
                                <SelectSearch
                                    label="Default Purchase UOM"
                                    style={{ height: '30px' }}
                                    list={extraData.uoms}
                                    getOptionLabel={(item) => item.name}
                                    getOptionValue={(item) => item.name}
                                    value={formData.default_purchase_uom}
                                    onChange={(val) => onFieldChange('default_purchase_uom', val)}
                                />
                            </div>
                            <div style={{ flex: 1 }}>
                                <Input
                                    label="Safety Stock"
                                    style={{ height: '30px' }}
                                    value={formData.safety_stock}
                                    onChange={(e) => onFieldChange('safety_stock', e.target.value)}
                                />
                            </div>
                            <div style={{ flex: 1, display: 'flex', alignItems: 'center', marginTop: '20px' }}>
                                <CheckboxNew
                                    id="allow_purchase"
                                    label="Allow Purchase"
                                    labelPosition="right"
                                    checked={formData.allow_purchase}
                                    onChange={(e) => onFieldChange('allow_purchase', e.target.checked)}
                                />
                            </div>
                        </div>

                        <div style={{ display: 'flex', gap: '15px', marginBottom: '10px' }}>

                            <div style={{ flex: 1 }}>
                                <Input
                                    label="Minimum Order Qty"
                                    style={{ height: '30px' }}
                                    value={formData.minimum_order_qty}
                                    onChange={(e) => onFieldChange('minimum_order_qty', e.target.value)}
                                />
                            </div>
                            <div style={{ flex: 1 }}>
                                <Input
                                    label="Lead Time (Days)"
                                    style={{ height: '30px' }}
                                    value={formData.lead_time_in_days}
                                    onChange={(e) => onFieldChange('lead_time_in_days', e.target.value)}
                                />
                            </div>
                            <div style={{ flex: 1, display: 'flex', alignItems: 'center', marginTop: '20px' }}>
                                <CheckboxNew
                                    id="is_customer_provided_item"
                                    label="Is Customer Provided Item"
                                    labelPosition="right"
                                    checked={formData.is_customer_provided_item}
                                    onChange={(e) => onFieldChange('is_customer_provided_item', e.target.checked)}
                                />
                            </div>
                        </div>


                    </div>
                </div>

                {/* Right Side - Foreign Trade Details */}
                <div style={{ width: '50%' }}>
                    <div
                        style={{
                            backgroundColor: '#E3F5DF',
                            height: '100%',
                            borderRadius: '4px',
                            display: 'flex',
                            flexDirection: 'column',
                            width: '100%',
                            padding: '10px',
                        }}
                    >
                        <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Foreign Trade Details</p>

                        <div style={{ display: 'flex', gap: '15px', marginBottom: '10px',marginTop : '10px' }}>
                            <div style={{ flex: 1 }}>
                                <Input
                                    label="Country of Origin"
                                    style={{ height: '30px' }}
                                    value={formData.country_of_origin}
                                    onChange={(e) => onFieldChange('country_of_origin', e.target.value)}
                                />
                            </div>
                            <div style={{ flex: 1 }}>
                                <Input
                                    label="Customs Tariff Number"
                                    style={{ height: '30px' }}
                                    value={formData.customs_tariff_number}
                                    onChange={(e) => onFieldChange('customs_tariff_number', e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default PurchasingDetails;
